import type { JSX } from "react";

import { ErrorState } from "../../components/data/ErrorState.js";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card.js";
import { Skeleton } from "../../components/ui/skeleton.js";
import { useMeQuery } from "../../lib/api/auth.js";

export function AccountPage(): JSX.Element {
  const meQuery = useMeQuery();

  if (meQuery.isLoading) {
    return (
      <div className="space-y-3">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-24 w-full max-w-md" />
      </div>
    );
  }

  if (meQuery.isError) {
    return (
      <ErrorState error={meQuery.error} onRetry={() => void meQuery.refetch()} />
    );
  }

  const user = meQuery.data;
  if (!user) return <ErrorState error={new Error("No user data")} />;

  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">Account</h1>
        <p className="text-sm text-muted-foreground">Your profile and tenant.</p>
      </header>
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Profile</CardTitle>
        </CardHeader>
        <CardContent>
          <dl className="grid grid-cols-1 gap-y-3 text-sm sm:grid-cols-3">
            <dt className="text-muted-foreground">Email</dt>
            <dd className="col-span-2 text-foreground">{user.email}</dd>
            <dt className="text-muted-foreground">Tenant</dt>
            <dd className="col-span-2 font-mono text-xs text-foreground">{user.tenantId}</dd>
            <dt className="text-muted-foreground">Role</dt>
            <dd className="col-span-2 text-foreground">{user.role}</dd>
          </dl>
        </CardContent>
      </Card>
    </div>
  );
}
